import { SSR_INITIAL_DATA_ID } from "@shared/ssrInitialData";
import type { SSRData } from "../contexts/SSRDataContext";

export function readInitialData(doc: Document = document): SSRData {
  const json = doc.getElementById(SSR_INITIAL_DATA_ID)?.textContent;
  return json ? JSON.parse(json) : {};
}
